module.exports = __webpack_public_path__ + "img/SLIDERS.8aee75bf.svg";